module.exports = __webpack_public_path__ + "img/IncredEvent-Mobile-Dark.87e8d7cc.webp";